import { render, staticRenderFns } from "./DigitalIdSection.vue?vue&type=template&id=bb685a6e&scoped=true&"
import script from "./DigitalIdSection.vue?vue&type=script&lang=js&"
export * from "./DigitalIdSection.vue?vue&type=script&lang=js&"
import style0 from "./DigitalIdSection.vue?vue&type=style&index=0&id=bb685a6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb685a6e",
  null
  
)

export default component.exports